import { FETCH_USER_WALLETS_REQUEST, FETCH_USER_WALLETS_SUCCESS,FETCH_USER_WALLETS_FAILURE } from "../actions/walletActions";


const initialState = {
    usersWallets: [],
    isLoading: false,
    error: null
};

export const walletsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_WALLETS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_USER_WALLETS_SUCCESS:
            return { ...state, usersWallets: action.payload, isLoading: false };

        case FETCH_USER_WALLETS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        default:
            return state;
    }
};
